import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PositionFromProps } from '../../utils/styledcomponents';
import type { PositionProps } from '../../utils/styledcomponents';
import Assets from '../../assets/Assets';

interface Props {
	className?: string;
	rotate?: number;
}

const Shadow = styled.div`
	filter: drop-shadow(${(props) => props.theme.shadow.pointer});
`;

const Arrow = styled(Assets.images.pointer)<{
	rotation: number;
}>`
	color: ${(props) => props.theme.colors.darkRed};
	position: absolute;
	transform-origin: right center;
	height: 10vmin;
	width: 18vmin;
	transform: translateX(-18vmin) translateY(-5vmin)
		rotate(${(props) => props.rotation}deg);
`;

const Pointer: FunctionComponent<Props> = (props: Props) => {
	const { rotate, className } = props;

	return (
		<Shadow className={className}>
			<Arrow rotation={rotate ?? 0} />
		</Shadow>
	);
};

export default styled(Pointer)<PositionProps>(PositionFromProps);
